const commons = {
  basePath: "/blocks",
  singular: "personnalisation",
  plural: "personnalisations",
  gender: "female",
};

export default commons;
